import { useTranslation } from 'react-i18next';
import type { AppLocale } from '@/shared/format/locale-data';
import { currentLocale } from './index';

/** Текущий язык интерфейса (ru | kk). */
export function useLocale(): AppLocale {
  const { i18n } = useTranslation();
  return currentLocale(i18n);
}
